"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Gear = function Gear(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Gear"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "gear"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 11.1v-2.28l-2.78-0.96-0.64-1.56 1.26-2.64-1.64-1.58-2.56 1.3-1.56-0.62-0.98-2.76h-2.28l-0.9 2.78-1.6 0.64-2.62-1.26-1.62 1.64 1.3 2.58-0.64 1.56-2.74 0.96v2.28l2.78 0.96 0.64 1.56-1.26 2.6 1.66 1.62 2.58-1.32 1.56 0.64 0.94 2.76h2.28l0.88-2.78 1.6-0.64 2.62 1.26 1.62-1.66-1.32-2.58 0.68-1.56 2.74-0.96zM10 14.28c-0.006 0-0.013 0-0.020 0-2.375 0-4.3-1.925-4.3-4.3s1.925-4.3 4.3-4.3c2.375 0 4.3 1.925 4.3 4.3 0 0.007-0 0.014-0 0.021v-0.001c0 2.364-1.916 4.28-4.28 4.28v0z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = Gear;
exports["default"] = _default;